/**
 * Zoom slot component.  @deprecated Zoom is deprecated, please use `<[Chart].Zoom/>`` instead.
 */
export const Zoom = () => null;
/* oxlint-disable-next-line typescript/no-deprecated */
Zoom['displayName'] = 'Zoom';
